import 'icheck';
import 'icheck/skins/flat/orange.css';

$(document).ready(() => {
  $('input.icheck').iCheck({
    checkboxClass: 'icheckbox_flat-orange',
    radioClass: 'iradio_flat-orange',
  });
});
